import React from "react";

class CallForsession extends React.Component {
  componentDidMount() {
    document.title = "Call For Session";
  }
  render() {
    return (
      <div>
        <div className="intro">
          <div className="container">
            <div className="row">
              <div className="col text-center">
                <div className="section_title_container text-center">
                  <div className="contact_title">
                    <h1> Call for Session</h1>
                  </div>
                </div>
                <div className="intro_left_content text_left">
                  <p align="left">
                    The purpose of ICITA is to provide a platform for academics
                    and professionals in computer technology to{" "}
                    <b>
                      publish, present, meet, exchange ideas, and establish
                      professional networks.
                    </b>{" "}
                    It is a forum for specific disciplinary research, as well as
                    on multi-disciplinary studies.{" "}
                  </p>
                  <p align="left">
                    Topics for publication and presentation can include, but are
                    not limited to the following research and development
                    areas/fields:
                  </p>

                  <div align="left">
                    <div>
                      <b>Cloud Computing</b>
                    </div>
                    <ul style={{ listStyleType: "circle" }} align="left">
                      <li> Public / Hybrid / Private cloud </li>
                      <li>Cloud architecture</li>
                      <li>Cloud platforms</li>
                      <li>Cloud infrastructure</li>
                      <li>Cloud applications</li>
                      <li>Cloud clients</li>
                      <li>
                        Social, ethical and privacy issues surrounding cloud
                        computing
                      </li>
                    </ul>
                  </div>
                  <div align="left">
                    <div>
                      <b>Intelligent Computing</b>
                    </div>
                    <ul style={{ listStyleType: "circle" }} align="left">
                      <li> Agent-based modeling</li>
                      <li>Computer vision</li>
                      <li>Signal and Image/Video Processing</li>
                      <li>Biomedical Engineering</li>
                      <li>Robotics</li>
                      <li>IOT </li>
                    </ul>
                  </div>
                  <div align="left">
                    <div>
                      <b>Artificial Intelligence</b>
                    </div>
                    <ul style={{ listStyleType: "circle" }} align="left">
                      <li>Machine Learning </li>
                      <li>Deep Learning </li>
                      <li>Data Mining</li>
                      <li>Natural Language Processing</li>
                      <li>Computational Intelligence </li>
                      <li>Evolutionary Computation </li>
                    </ul>
                  </div>
                  <div align="left">
                    <div>
                      <b>Data Science</b>
                    </div>
                    <ul style={{ listStyleType: "circle" }} align="left">
                      <li>Knowledge Discovery and Data Mining </li>
                      <li>Big Data </li>
                      <li>Big Data Infrastructure</li>
                      <li>Data Visualisation & Analytics</li>
                      <li>Data warehousing </li>
                      <li>Data fusion</li>
                    </ul>
                  </div>

                  <div align="left">
                    <div>
                      <b>Graphics and Games Programming</b>
                    </div>
                    <ul style={{ listStyleType: "circle" }} align="left">
                      <li>
                        Destructible Environments in GT (Games Technology){" "}
                      </li>
                      <li>Ray Tracing and PBR (Physically Based Rendering) </li>
                      <li>ESG (Educational Serious Games) </li>
                      <li>Computational Geometry </li>
                    </ul>
                  </div>

                  <div align="left">
                    <div>
                      <b>Ontologies</b>
                    </div>
                    <ul style={{ listStyleType: "circle" }} align="left">
                      <li>Ontology engineering </li>
                      <li>
                        Ontology driven development of information and
                        knowledge-based systems{" "}
                      </li>
                      <li>
                        Ontology driven information and knowledge-based systems{" "}
                      </li>
                      <li>
                        Ontologies for different domains and applications{" "}
                      </li>
                    </ul>
                  </div>
                  <div align="left">
                    <div>
                      <b>Software Engineering</b>
                    </div>
                    <ul style={{ listStyleType: "circle" }} align="left">
                      <li>Software Engineering Practice </li>
                      <li>Emerging ideas in Software Engineering</li>
                      <li>Software Engineering and Security</li>
                      <li>Software Architecture</li>
                    </ul>
                  </div>
                  <div align="left">
                    <div>
                      <b>Online Learning</b>
                    </div>
                    <ul style={{ listStyleType: "circle" }} align="left">
                      <li>Digital Media Design</li>
                      <li>Online Assessment</li>
                      <li>Open Learning</li>
                      <li>Synchronous and Asynchronous Learning</li>
                      <li>Learner Engagement</li>
                    </ul>
                  </div>
                  <div align="left">
                    <div>
                      <b>General topics</b>
                    </div>
                    <ul style={{ listStyleType: "circle" }} align="left">
                      <li>IT in Health Care</li>
                      <li>
                        Remote Sensing, GIS, Instrumentation and Biomedical
                        Engineering
                      </li>
                      <li>Multimedia</li>
                      <li>IT and computing education</li>
                      <li>
                        Engineering Applications of IT - CAD/CAM, CAE, CIM, CNC
                      </li>
                      <li>Computer Networking</li>
                      <li>Web Content Generation, Usage and Management</li>
                      <li>IT and computing workplace issues and ethics</li>
                      <li>Telecommunication and Mobile Communications</li>
                      <li>High Performance Computing</li>
                      <li>Telecommunication and Information Management</li>
                      <li>Human Computer Interaction</li>
                      <li>Electronic Design Automation</li>
                      <li>Signal and Information Processing</li>
                      <li>Information and Communication Systems</li>
                      <li>
                        Fuzzy Logic, Reasoning and Computational Intelligence
                      </li>
                      <li>Mobile Data Communications&nbsp;</li>
                    </ul>
                  </div>
                  <div align="left">
                    <div>
                      <b>Conference Tracks</b>
                    </div>
                    <ul style={{ listStyleType: "circle" }} align="left">
                      <li>Cloud computing  </li>
                      <li>Business Process Engineering</li>
                      <li>Machine learning</li>
                      <li>Evolutionary Computing</li>
                      <li>Big Data Analytics</li>
                      <li>Internet of Things and Cyber-Physical Systems</li>
                      <li>Information and Knowledge Management</li>
                      <li>Computer Vision and Image Processing</li>
                      <li>Computer Graphics and Games Programming </li>
                      <li>Mobile Computing</li>
                      <li>Ontology Engineering</li>
                      <li>Software and Systems Modelling</li>
                      <li>Human Computer Interaction</li>
                      <li>Online Learning / E- Learning</li>
                      <li>Computer Networks</li>
                      <li>Web Engineering&nbsp;</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default CallForsession;
